import { useMutation } from '@apollo/client';
import { Mutation, MutationResendVerificationCodeArgs } from 'graphql/generated/graphqlTypes';
import { RESEND_VERIFICATION_CODE } from 'graphql/mutations';
import { BaseHookProps } from '../shared/types';

const useResendVerificationCode = ({ handleFetchError }: BaseHookProps) => {
  const [resendVerificationCodeMutation, { loading }] = useMutation<
    Pick<Mutation, 'resendVerificationCode'>,
    MutationResendVerificationCodeArgs
  >(RESEND_VERIFICATION_CODE, {
    onError: () => {
      handleFetchError('Error while resending verification code');
    }
  });

  const resendVerificationCode = async (email: string) => {
    await resendVerificationCodeMutation({
      variables: {
        email
      }
    });
  };

  return {
    loading,
    resendVerificationCode
  };
};

export default useResendVerificationCode;
